import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { LoaderModule } from '@progress/kendo-angular-indicators';

@Component({
  selector: 'app-loading-indicator',
  standalone: true,
  imports: [
    LoaderModule,
    NgIf
  ],
  templateUrl: './loading-indicator.component.html',
  styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent {
  @Input() isLoading: boolean = false;
  @Input() loadingMessage: string = 'Loading...';
}
